import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { useTranslate } from 'react-admin';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
}));

const ParamDateInput = ({
    onChange = (value) => console.warn('Define onChange param to handle select changes', value),
    label
}) => {
    const translate = useTranslate();
    const [dateValue, setDateValue] = useState(new Date());
    const classes = useStyles();

    useEffect(() => {
        onChange(format(dateValue, 'yyyy-MM-dd'));
    }, [dateValue, onChange]);

    const handleChange = (date) => {
        setDateValue(date);
    };

    return (
        <FormControl className={classes.formControl}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    format="dd/MM/yyyy"
                    value={dateValue}
                    onChange={handleChange}
                    inputProps={{ readOnly: true }}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    label={translate(label, 1)}
                />
            </MuiPickersUtilsProvider>
        </FormControl>
    );
};

export default ParamDateInput;